import { render } from "./CommonOverview.vue?vue&type=template&id=1f4677e2&scoped=true&ts=true"
import script from "./CommonOverview.vue?vue&type=script&lang=ts"
export * from "./CommonOverview.vue?vue&type=script&lang=ts"

import "./CommonOverview.vue?vue&type=style&index=0&id=1f4677e2&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4677e2"]])

export default __exports__